import styled from 'styled-components';
import { FlexBox, Colors } from '@brg/ui';
import { RectangularButtonFilled } from '../buttons';
import { LayoutConst } from 'core/modules';

export const LegalsWarningWrapper = styled(FlexBox)`
  position: fixed;
  z-index: 99999;
  bottom: 0;
  left: 0;
  padding: 0;
  height: 64px;
  width: 100%;
  background-color: #f2f2f2;
  flex-flow: column;
  place-items: center;
  justify-content: center;
  margin: 0 auto;
  

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    height: 80px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    max-height: 148px;
    height: auto;
  }
`

export const LegalsApproveButton = styled(FlexBox)`
    width: 172px;
    height: 32px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    background-color: ${Colors.galBlack73};
    color: #fff;
    cursor: pointer;
    justify-content: center;
    place-items: center;
    border-radius: 3px;
    margin-left: 64px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #151514;
      transition: background-color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      margin: 0 auto;
      margin-top: 16px;
    }
`;

export const LegalsText = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack61};
    white-space: pre-line;
    width: 100%;
    display: inline-block;

    .modal-link {
        text-decoration: underline;
    }

    a {
        text-decoration: underline !important;
        cursor: pointer;
        color: ${Colors.galBlack61};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
    }
`;import styled from 'styled-components';
import { FlexBox, Colors } from '@brg/ui';
import { RectangularButtonFilled } from '../buttons';
import { LayoutConst } from 'core/modules';

export const LegalsWarningWrapper = styled(FlexBox)`
  position: fixed;
  z-index: 99999;
  bottom: 0;
  left: 0;
  padding: 0;
  height: 64px;
  width: 100%;
  background-color: #f2f2f2;
  flex-flow: column;
  place-items: center;
  justify-content: center;
  margin: 0 auto;
  

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    height: 80px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    max-height: 148px;
    height: auto;
  }
`

export const LegalsApproveButton = styled(FlexBox)`
    width: 172px;
    height: 32px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    background-color: ${Colors.galBlack73};
    color: #fff;
    cursor: pointer;
    justify-content: center;
    place-items: center;
    border-radius: 3px;
    margin-left: 64px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #151514;
      transition: background-color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      margin: 0 auto;
      margin-top: 16px;
    }
`;

export const LegalsText = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack61};
    white-space: pre-line;
    width: 100%;
    display: inline-block;

    .modal-link {
        text-decoration: underline;
    }

    a {
        text-decoration: underline !important;
        cursor: pointer;
        color: ${Colors.galBlack61};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
    }
`;